// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/search-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/arrow-up.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.add-user .role-check-container .table-container {
  max-height: 30vh;
  overflow-y: auto;
  margin-bottom: 100px; }

.add-user .form-floating > .form-control:focus ~ label, .add-user .form-floating > .form-control:not(:placeholder-shown) ~ label, .add-user .form-floating > .form-control-plaintext ~ label, .add-user .form-floating > .form-select ~ label {
  color: white;
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }

.add-user .form-floating > .form-control:focus ~ label::after, .add-user .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .add-user .form-floating > .form-control-plaintext ~ label::after, .add-user .form-floating > .form-select ~ label::after {
  background-color: unset; }

.users {
  color: #fff;
  background-color: #050e25;
  height: 100vh;
  width: 100%;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 90px; }
  .users .users-title-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between; }
    .users .users-title-bar select.form-select {
      background-color: #021d3e;
      border: unset;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 15px;
      padding-bottom: 15px;
      color: #fff;
      margin-right: 39px;
      margin-bottom: 10px;
      width: 200px;
      height: 34px; }
      .users .users-title-bar select.form-select::placeholder {
        color: lightgray;
        background-color: #4fc22c;
        opacity: .5;
        padding-left: 5px;
        padding-bottom: 20px;
        transform: translateY(-30px); }
    .users .users-title-bar #users-organizations {
      font-size: 1rem;
      height: auto;
      text-align: center;
      border-radius: 5px;
      width: 240px; }
      .users .users-title-bar #users-organizations::placeholder {
        background-color: white;
        opacity: .5;
        padding-left: 1px;
        transform: trans lateY(-30px);
        padding-bottom: 20px; }
  .users .users-nav-container {
    margin-bottom: 12px; }
    .users .users-nav-container .users-nav-item {
      opacity: 0.5; }
    .users .users-nav-container .users-nav-item .nav-link {
      font-size: 1.2rem; }
    .users .users-nav-container .users-nav-item-active {
      border-bottom: solid 4px #4fc22c;
      opacity: 1 !important; }
  .users .users-container {
    height: calc(100% - 210px); }
  .users .users-profiles-container {
    height: calc(100% - 210px); }
  .users .users-tool-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 22px;
    align-items: center; }
    .users .users-tool-container button {
      height: 40px; }
  .users .users-search {
    height: 40px;
    margin-bottom: 20px; }
  .users .users-search input {
    border: none !important;
    border-radius: 4px;
    width: 300px !important;
    background-color: #0b1736 !important;
    color: #fff;
    text-indent: 22px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-color: #060e21;
    background-position: 6px 9px; }
    .users .users-search input::placeholder {
      color: white;
      opacity: .5; }
  .users .users-search-users {
    text-indent: 15px  !important; }
  .users .users-button {
    background-color: unset !important;
    border-radius: 7px;
    border: 2px solid #4fc2d9 !important;
    align-self: flex-end; }
    .users .users-button:hover, .users .users-button:focus {
      color: #4fc2d9 !important;
      background-color: #12234f !important; }
  .users .ct-table-button {
    margin-right: 10px;
    background-color: unset !important;
    height: 1.7rem;
    width: 2.7rem; }
    .users .ct-table-button svg {
      color: #4fc2d9 !important;
      pointer-events: none;
      width: 1rem;
      height: 1rem;
      vertical-align: 1em; }
  .users .ct-table-button-disabled {
    pointer-events: none; }
    .users .ct-table-button-disabled svg {
      color: gray !important;
      pointer-events: none; }
  .users .ct-table-container-button {
    max-width: 130px; }
  .users .users-pagination {
    display: none;
    justify-content: flex-end;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr !important;
    margin-top: 5px;
    margin-left: 30px;
    color: white; }
    .users .users-pagination .page-item {
      padding-right: 1px;
      border-radius: 2px;
      margin-left: 5px; }
      .users .users-pagination .page-item a {
        background-color: #0b1736;
        color: white;
        border-radius: 2px; }
  .users .table-container {
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000;
    display: flex;
    position: relative;
    margin-top: 10px;
    height: 100%;
    overflow-y: auto;
    height: -webkit-fill-available;
    height: fill-available;
    height: calc(100% - 48px); }
  .users .reportTable {
    min-height: 10vh;
    color: white; }
  .users .table-parent-container {
    border-radius: 2px;
    margin-top: 10px;
    overflow-x: hidden;
    margin-right: 20px;
    overflow-y: hidden;
    height: calc(100% - 150px);
    min-height: 40vh;
    color: white; }
    .users .table-parent-container table {
      color: #fff;
      font-size: 1.2vw;
      border: unset;
      overflow-y: auto; }
      .users .table-parent-container table td,
      .users .table-parent-container table tr,
      .users .table-parent-container table th,
      .users .table-parent-container table thead,
      .users .table-parent-container table tbody {
        font-weight: unset;
        border: unset;
        font-size: 1.2vw; }
      .users .table-parent-container table thead > tr > :nth-child(1) {
        border-bottom: 0.5px solid #222224;
        border-right: 0.5px solid #222224; }
      .users .table-parent-container table thead > tr > th:not(:first-child) {
        border-bottom: 0.5px solid #222224;
        border-left: 0.5px solid #222224; }
      .users .table-parent-container table tbody > tr > td:not(:first-child) {
        border-left: 0.5px solid #222224; }
      .users .table-parent-container table tbody > tr:hover {
        background-color: #021d3e;
        cursor: pointer; }
      .users .table-parent-container table tbody > tr > td.principal {
        border-top: 0.5px solid #222224; }
      .users .table-parent-container table .sub > td:nth-child(1) {
        padding-left: 30px; }
      .users .table-parent-container table .principal {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
        background-repeat: no-repeat;
        background-position: right 10px top 14px; }
      .users .table-parent-container table .principal.active {
        color: #4fc2d9;
        background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
        background-repeat: no-repeat;
        background-position: right 10px top 14px; }
  .users .container {
    margin-left: unset;
    padding-left: unset; }
    .users .container input,
    .users .container select {
      margin-bottom: 50px; }
  .users .footer {
    position: relative;
    bottom: 30px;
    left: 0px;
    z-index: 1; }
  .users .org-table-header {
    flex-direction: row;
    display: flex;
    align-self: self-end;
    width: 330px;
    justify-content: space-between; }
  .users .form-check {
    text-align: left;
    margin: unset;
    padding: unset;
    margin-bottom: 0px !important;
    margin-right: 20px;
    align-self: center; }
    .users .form-check input[type='checkbox'] {
      border-color: unset;
      width: 20px;
      height: 20px;
      padding: unset;
      margin: unset;
      background: transparent;
      border: 1px #fff solid;
      margin-right: 10px;
      cursor: pointer; }
    .users .form-check input[type='checkbox']:checked {
      background: #4fc2d9;
      color: #0b1736; }
    .users .form-check label.form-check-label {
      text-align: left;
      color: #fff !important; }
  .users .role-check {
    margin-bottom: 20px; }
    .users .role-check .form-check {
      margin-bottom: unset; }
    .users .role-check select.reports-dropdownlist {
      background-color: transparent;
      border: unset;
      margin: unset;
      padding: unset;
      padding-left: 30px;
      width: 200px; }
  .users .add-company {
    margin-bottom: 30px;
    cursor: pointer; }
    .users .add-company img {
      margin-right: 10px; }
  .users .form-check-label {
    cursor: pointer; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/users/users.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACfrD;EAIM,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB,EAAA;;AAN1B;EAYM,YAAY;EACZ,aAAa;EACb,8DAA8D,EAAA;;AAdpE;EAkBM,uBAAuB,EAAA;;AAI7B;EACC,WD/BsB;ECgCtB,yBDnBuC;ECoBvC,aAAa;EACb,WAAW;EACX,kBAjCqB;EAkCrB,mBAlCqB;EAmCrB,iBAlCoB,EAAA;EA2BrB;IAYE,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IAdhC;MAkBG,yBD9B2B;MC+B3B,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,iBAAiB;MACjB,oBAAoB;MACpB,WDtDoB;MCuDpB,kBAAkB;MAClB,mBAAmB;MACnB,YAAY;MACZ,YAAY,EAAA;MA5Bf;QA+BI,gBAAgB;QAChB,yBAAyB;QACzB,WAAW;QACX,iBAAiB;QACjB,oBAAoB;QACpB,4BAA4B,EAAA;IApChC;MAyCG,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,YAAY,EAAA;MA7Cf;QAgDI,uBAAuB;QACvB,WAAW;QACX,iBAAiB;QACjB,6BAA6B;QAC7B,oBAAoB,EAAA;EApDxB;IA0DE,mBAAmB,EAAA;IA1DrB;MA6DG,YAAY,EAAA;IA7Df;MAiEG,iBAAiB,EAAA;IAjEpB;MAqEG,gCAAgC;MAChC,qBAAqB,EAAA;EAtExB;IA2EE,0BAA0B,EAAA;EA3E5B;IA+EE,0BAA0B,EAAA;EA/E5B;IAmFE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB,EAAA;IAvFrB;MA0FG,YAAY,EAAA;EA1Ff;IA+FE,YAAY;IACZ,mBAAmB,EAAA;EAhGrB;IAoGE,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,oCAAoC;IACpC,WAAW;IACX,iBAAiB;IACjB,mDAA6C;IAC7C,4BAA4B;IAC5B,yBD9HiC;IC+HjC,4BAA4B,EAAA;IA7G9B;MAgHI,YAAY;MACZ,WAAW,EAAA;EAjHf;IAsHE,6BAA6B,EAAA;EAtH/B;IA0HE,kCAAkC;IAClC,kBAAkB;IAClB,oCAAiD;IACjD,oBAAoB,EAAA;IA7HtB;MAiIG,yBAAsC;MACtC,oCAA8D,EAAA;EAlIjE;IAuIE,kBAAkB;IAClB,kCAAkC;IAClC,cAAc;IACd,aAAa,EAAA;IA1If;MA6IG,yBAAsC;MACtC,oBAAoB;MACpB,WAAW;MACX,YAAY;MACZ,mBAAmB,EAAA;EAjJtB;IAsJE,oBAAoB,EAAA;IAtJtB;MAyJG,sBAAsB;MACtB,oBAAoB,EAAA;EA1JvB;IA+JE,gBAAgB,EAAA;EA/JlB;IAmKE,aAAa;IACb,yBAAyB;IACzB,qDAAqD;IACrD,eAAe;IACf,iBAAiB;IAEjB,YAAY,EAAA;IAzKd;MA4KG,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB,EAAA;MA9KnB;QAiLI,yBD5M4B;QC6M5B,YAAY;QACZ,kBAAkB,EAAA;EAnLtB;IAyLE,yBDpN8B;ICqN9B,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAEhB,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB,EAAA;EApM3B;IAwME,gBAAgB;IAChB,YAAY,EAAA;EAzMd;IA6ME,kBAAkB;IAElB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY,EAAA;IArNd;MAwNG,WDtPoB;MCuPpB,gBAjPkB;MAkPlB,aAAa;MACb,gBAAgB,EAAA;MA3NnB;;;;;QAkOI,kBAAkB;QAClB,aAAa;QACb,gBA5PiB,EAAA;MAwBrB;QAwOI,kCAlQ2B;QAmQ3B,iCAnQ2B,EAAA;MA0B/B;QA6OI,kCAvQ2B;QAwQ3B,gCAxQ2B,EAAA;MA0B/B;QAkPI,gCA5Q2B,EAAA;MA0B/B;QAsPI,yBDlQ0B;QCmQ1B,eAAe,EAAA;MAvPnB;QA2PI,+BArR2B,EAAA;MA0B/B;QA+PI,kBAAkB,EAAA;MA/PtB;QAmQI,mDAA4C;QAC5C,4BAA4B;QAC5B,wCAAwC,EAAA;MArQ5C;QAyQI,cDtSwB;QCuSxB,mDAA0C;QAC1C,4BAA4B;QAC5B,wCAAwC,EAAA;EA5Q5C;IAqRE,kBAAkB;IAClB,mBAAmB,EAAA;IAtRrB;;MA0RG,mBAAmB,EAAA;EA1RtB;IA+RE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU,EAAA;EAlSZ;IAsSE,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,8BAA8B,EAAA;EA1ShC;IA8SE,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB,EAAA;IAnTpB;MAsTG,mBAAmB;MACnB,WAAW;MACX,YAAY;MACZ,cAAc;MACd,aAAa;MACb,uBAAuB;MACvB,sBAAsB;MACtB,kBAAkB;MAClB,eAAe,EAAA;IA9TlB;MAkUG,mBD/VyB;MCgWzB,cD/VqB,EAAA;IC4BxB;MAuUG,gBAAgB;MAChB,sBAAoC,EAAA;EAxUvC;IA8UE,mBAAmB,EAAA;IA9UrB;MAiVG,oBAAoB,EAAA;IAjVvB;MAqVG,6BAA6B;MAC7B,aAAa;MACb,aAAa;MACb,cAAc;MACd,kBAAkB;MAElB,YAAY,EAAA;EA3Vf;IAkWE,mBAAmB;IACnB,eAAe,EAAA;IAnWjB;MAsWG,kBAAkB,EAAA;EAtWrB;IA4WE,eAAe,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import '../../theme/_variables.scss';\n\n$paddingLeftSize: 40px;\n$paddingTopSize: 90px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n\n.add-user {\n   .role-check-container{\n\n   \t\t.table-container {\n   \t\t\tmax-height: 30vh;\n\t\t    overflow-y: auto;\n\t\t    margin-bottom: 100px;\n   \t\t}\n\n   }\n\n  .form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {\n      color: white;   \n      opacity: 0.65;\n      transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n  }\n\n  .form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after {\n      background-color: unset; \n  }\n}\n\n.users {\n\tcolor: $primaryFontColor;\n\tbackground-color: $containerScreenBackgroundColor;\n\theight: 100vh;\n\twidth: 100%;\n\tpadding-left: $paddingLeftSize;\n\tpadding-right: $paddingLeftSize;\n\tpadding-top: $paddingTopSize;\n\n  \n\n\t.users-title-bar {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: space-between;\n\n\t\tselect.form-select,\n\t\t{\n\t\t\tbackground-color: $inputBackgroundColor;\n\t\t\tborder: unset;\n\t\t\tpadding-left: 20px;\n\t\t\tpadding-right: 20px;\n\t\t\tpadding-top: 15px;\n\t\t\tpadding-bottom: 15px;\n\t\t\tcolor: $primaryFontColor;\n\t\t\tmargin-right: 39px;\n\t\t\tmargin-bottom: 10px;\n\t\t\twidth: 200px;\n\t\t\theight: 34px;\n\n\t\t\t&::placeholder {\n\t\t\t\tcolor: lightgray;\n\t\t\t\tbackground-color: #4fc22c;\n\t\t\t\topacity: .5;\n\t\t\t\tpadding-left: 5px;\n\t\t\t\tpadding-bottom: 20px;\n\t\t\t\ttransform: translateY(-30px);\n\t\t\t}\n\t\t}\n\n\t\t#users-organizations {\n\t\t\tfont-size: 1rem;\n\t\t\theight: auto;\n\t\t\ttext-align: center;\n\t\t\tborder-radius: 5px;\n\t\t\twidth: 240px;\n\n\t\t\t&::placeholder {\n\t\t\t\tbackground-color: white;\n\t\t\t\topacity: .5;\n\t\t\t\tpadding-left: 1px;\n\t\t\t\ttransform: trans lateY(-30px);\n\t\t\t\tpadding-bottom: 20px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.users-nav-container {\n\t\tmargin-bottom: 12px;\n\n\t\t.users-nav-item {\n\t\t\topacity: 0.5;\n\t\t}\n\n\t\t.users-nav-item .nav-link {\n\t\t\tfont-size: 1.2rem;\n\t\t}\n\n\t\t.users-nav-item-active {\n\t\t\tborder-bottom: solid 4px #4fc22c;\n\t\t\topacity: 1 !important;\n\t\t}\n\t}\n\n\t.users-container {\n\t\theight: calc(100% - 210px);\n\t}\n\n\t.users-profiles-container {\n\t\theight: calc(100% - 210px);\n\t}\n\n\t.users-tool-container {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: space-between;\n\t\tpadding-right: 22px;\n\t\talign-items: center;\n\n\t\tbutton {\n\t\t\theight: 40px;\n\t\t}\n\t}\n\n\t.users-search {\n\t\theight: 40px;\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.users-search input {\n\t\tborder: none !important;\n\t\tborder-radius: 4px;\n\t\twidth: 300px !important;\n\t\tbackground-color: #0b1736 !important;\n\t\tcolor: #fff;\n\t\ttext-indent: 22px;\n\t\tbackground: url(../../assets/search-icon.svg);\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-color: $inputFocusBackgroundColor;\n\t\tbackground-position: 6px 9px;\n\n\t\t\t&::placeholder {\n\t\t\t\tcolor: white;\n\t\t\t\topacity: .5;\n\t\t\t}\n\t}\n\n\t.users-search-users {\n\t\ttext-indent: 15px  !important;\n\t}\n\n\t.users-button {\n\t\tbackground-color: unset !important;\n\t\tborder-radius: 7px;\n\t\tborder: 2px solid $secundaryFontColor  !important;\n\t\talign-self: flex-end;\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: $secundaryFontColor  !important;\n\t\t\tbackground-color: $darkAndLightModeBackgroundColor  !important;\n\t\t}\n\t}\n\n\t.ct-table-button {\n\t\tmargin-right: 10px;\n\t\tbackground-color: unset !important;\n\t\theight: 1.7rem;\n\t\twidth: 2.7rem;\n\n\t\tsvg {\n\t\t\tcolor: $secundaryFontColor  !important;\n\t\t\tpointer-events: none;\n\t\t\twidth: 1rem;\n\t\t\theight: 1rem;\n\t\t\tvertical-align: 1em;\n\t\t}\n\t}\n\n\t.ct-table-button-disabled {\n\t\tpointer-events: none;\n\n\t\tsvg{\n\t\t\tcolor: gray !important;\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\n\t.ct-table-container-button {\n\t\tmax-width: 130px;\n\t}\n\n\t.users-pagination {\n\t\tdisplay: none;\n\t\tjustify-content: flex-end;\n\t\tgrid-template-columns: 1fr 1fr 1fr 1fr 1fr !important;\n\t\tmargin-top: 5px;\n\t\tmargin-left: 30px;\n\n\t\tcolor: white;\n\n\t\t.page-item {\n\t\t\tpadding-right: 1px;\n\t\t\tborder-radius: 2px;\n\t\t\tmargin-left: 5px;\n\n\t\t\ta {\n\t\t\t\tbackground-color: $topMenuBackgroundColor;\n\t\t\t\tcolor: white;\n\t\t\t\tborder-radius: 2px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.table-container {\n\t\tbackground-color: $topMenuBackgroundColor;\n\t\tborder-radius: 2px;\n\t\tbox-shadow: 0px 0px 20px #000;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t\tmargin-top: 10px;\n\t\theight: 100%;\n\t\toverflow-y: auto;\n\t\theight: -moz-available;\n\t\theight: -webkit-fill-available;\n\t\theight: fill-available;\n\t\theight: calc(100% - 48px);\n\t}\n\n\t.reportTable {\n\t\tmin-height: 10vh;\n\t\tcolor: white;\n\t}\n\n\t.table-parent-container {\n\t\tborder-radius: 2px;\n\t\n\t\tmargin-top: 10px;\n\t\toverflow-x: hidden;\n\t\tmargin-right: 20px;\n\t\toverflow-y: hidden;\n\t\theight: calc(100% - 150px);\n\t\tmin-height: 40vh;\n\t\tcolor: white;\n\n\t\ttable {\n\t\t\tcolor: $primaryFontColor;\n\t\t\tfont-size: $tableFontSize;\n\t\t\tborder: unset;\n\t\t\toverflow-y: auto;\n\n\t\t\ttd,\n\t\t\ttr,\n\t\t\tth,\n\t\t\tthead,\n\t\t\ttbody {\n\t\t\t\tfont-weight: unset;\n\t\t\t\tborder: unset;\n\t\t\t\tfont-size: $tableFontSize;\n\t\t\t}\n\n\t\t\tthead>tr> :nth-child(1) {\n\t\t\t\tborder-bottom: $tableDividerLineBorderSize solid $tableDividerLineColor;\n\t\t\t\tborder-right: $tableDividerLineBorderSize solid $tableDividerLineColor;\n\t\t\t}\n\n\t\t\tthead>tr>th:not(:first-child) {\n\t\t\t\tborder-bottom: $tableDividerLineBorderSize solid $tableDividerLineColor;\n\t\t\t\tborder-left: $tableDividerLineBorderSize solid $tableDividerLineColor;\n\t\t\t}\n\n\t\t\ttbody>tr>td:not(:first-child) {\n\t\t\t\tborder-left: $tableDividerLineBorderSize solid $tableDividerLineColor;\n\t\t\t}\n\n\t\t\ttbody>tr:hover {\n\t\t\t\tbackground-color: $inputBackgroundColor;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\ttbody>tr>td.principal {\n\t\t\t\tborder-top: $tableDividerLineBorderSize solid $tableDividerLineColor;\n\t\t\t}\n\n\t\t\t.sub>td:nth-child(1) {\n\t\t\t\tpadding-left: 30px;\n\t\t\t}\n\n\t\t\t.principal {\n\t\t\t\tbackground: url(../../assets/arrow-down.svg);\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tbackground-position: right 10px top 14px;\n\t\t\t}\n\n\t\t\t.principal.active {\n\t\t\t\tcolor: $secundaryFontColor;\n\t\t\t\tbackground: url(../../assets/arrow-up.svg);\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tbackground-position: right 10px top 14px;\n\t\t\t}\n\t\t}\n\t}\n\n\n\n\n\t.container {\n\t\tmargin-left: unset;\n\t\tpadding-left: unset;\n\n\t\tinput,\n\t\tselect {\n\t\t\tmargin-bottom: 50px;\n\t\t}\n\t}\n\n\t.footer {\n\t\tposition: relative;\n\t\tbottom: 30px;\n\t\tleft: 0px;\n\t\tz-index: 1;\n\t}\n\n\t.org-table-header {\n\t\tflex-direction: row;\n\t\tdisplay: flex;\n\t\talign-self: self-end;\n\t\twidth: 330px;\n\t\tjustify-content: space-between;\n\t}\n\n\t.form-check {\n\t\ttext-align: left;\n\t\tmargin: unset;\n\t\tpadding: unset;\n\t\tmargin-bottom: 0px !important;\n\t\tmargin-right: 20px;\n\t\talign-self: center;\n\n\t\tinput[type='checkbox'] {\n\t\t\tborder-color: unset;\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tpadding: unset;\n\t\t\tmargin: unset;\n\t\t\tbackground: transparent;\n\t\t\tborder: 1px #fff solid;\n\t\t\tmargin-right: 10px;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\tinput[type='checkbox']:checked {\n\t\t\tbackground: $secundaryFontColor;\n\t\t\tcolor: $thirdFontColor;\n\t\t}\n\n\t\tlabel.form-check-label {\n\t\t\ttext-align: left;\n\t\t\tcolor: $primaryFontColor  !important;\n\t\t}\n\t}\n\n\n\t.role-check {\n\t\tmargin-bottom: 20px;\n\n\t\t.form-check {\n\t\t\tmargin-bottom: unset;\n\t\t}\n\n\t\tselect.reports-dropdownlist {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: unset;\n\t\t\tmargin: unset;\n\t\t\tpadding: unset;\n\t\t\tpadding-left: 30px;\n\n\t\t\twidth: 200px;\n\t\t}\n\n\n\t}\n\n\t.add-company {\n\t\tmargin-bottom: 30px;\n\t\tcursor: pointer;\n\n\t\timg {\n\t\t\tmargin-right: 10px;\n\t\t}\n\n\t}\n\n\t.form-check-label {\n\t\tcursor: pointer;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
